// app/pages/CentreManager/selectors.ts
import type { Centre } from "./actions";
import type { CentreState } from "./reducer";

// Fallback so UI won't crash before reducer is mounted
const fallbackState: CentreState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,
  filterName: "",
  showAll: false,
  modalOpen: false,
  editing: null,
};

// Try a few common mount points; if none found, return fallback
const selectSlice = (state: any): CentreState => {
  return (
    state?.CentreManager ||
    state?.centreManager ||
    state?.pages?.CentreManager ||
    state?.pages?.centreManager ||
    state?.modules?.CentreManager ||
    state?.modules?.centreManager ||
    fallbackState
  );
};

export const getCentreList = (state: any): Centre[] =>
  selectSlice(state).list;

export const getCentreLoading = (state: any): boolean =>
  selectSlice(state).loading;

export const getCentreSaving = (state: any): boolean =>
  selectSlice(state).saving;

export const getCentreError = (state: any): string | undefined =>
  selectSlice(state).error;

export const getFilterName = (state: any): string =>
  selectSlice(state).filterName;

export const getShowAll = (state: any): boolean =>
  selectSlice(state).showAll;

export const getModalOpen = (state: any): boolean =>
  selectSlice(state).modalOpen;

export const getEditingItem = (state: any): Centre | null =>
  selectSlice(state).editing;

export const getFilteredCentreList = (state: any): Centre[] => {
  const list = getCentreList(state) || [];
  const q = (getFilterName(state) || "").trim().toLowerCase();
  const showAll = !!getShowAll(state);

  let data = showAll ? list : list.filter(c => c.active);

  if (q) {
    data = data.filter(c =>
      (c.centreName ?? "").toLowerCase().includes(q) ||
      (c.centreCode ?? "").toLowerCase().includes(q) ||
      (c.country ?? "").toLowerCase().includes(q)
    );
  }

  return [...data].sort((a, b) => (a.centreName || "").localeCompare(b.centreName || ""));
};
